import {
  AuthProvider,
  createIdentityClient,
  createSessionEventBus,
  SessionBusProvider,
} from '@skylabs-digital/react-identity-access';
import {
  GlobalStateProvider,
  SnackbarContainer,
  SnackbarProvider,
} from '@skylabs-digital/react-proto-kit';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { AuthenticatedApiProvider } from './components/AuthenticatedApiProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import { getBoBaseUrl } from './config/auth.config';
import { AppLayout } from './layouts/AppLayout';
import { ActivityPage } from './pages/ActivityPage';
import { AppDetailPage } from './pages/AppDetailPage';
import { AppsPage } from './pages/AppsPage';
import { DashboardPage } from './pages/DashboardPage';
import { DuplicatesPage } from './pages/DuplicatesPage';
import { FilesPage } from './pages/FilesPage';
import { LoginPage } from './pages/LoginPage';
import { ProcessingPage } from './pages/ProcessingPage';
import { StoragePage } from './pages/StoragePage';
import { WebhooksPage } from './pages/WebhooksPage';

/** Un solo bus y un solo cliente del BFF (`/api/bo/auth/*`), creados fuera del árbol. */
const sessionBus = createSessionEventBus();
const identityClient = createIdentityClient({ baseUrl: getBoBaseUrl(), bus: sessionBus });

/**
 * Superficie de PLATAFORMA (como el backoffice de idachu y el de noten): sin
 * `AppProvider` ni `TenantProvider`, sus actores son usuarios de sistema con
 * contexto `(platform, admin)`. `initialRoles: []` apaga el catálogo de roles.
 */
export function App() {
  return (
    <GlobalStateProvider>
      <SessionBusProvider bus={sessionBus}>
        <AuthProvider
          config={{ client: identityClient, bus: sessionBus, bootstrap: 'eager', initialRoles: [] }}
        >
          <AuthenticatedApiProvider>
            <Router>
              <SnackbarProvider defaultDuration={4000} maxVisible={3}>
                <SnackbarContainer position="top-right" />
                <Routes>
                  <Route path="/login" element={<LoginPage />} />
                  <Route element={<ProtectedRoute />}>
                    <Route element={<AppLayout />}>
                      <Route path="/" element={<DashboardPage />} />
                      <Route path="/storage" element={<StoragePage />} />
                      <Route path="/apps" element={<AppsPage />} />
                      <Route path="/apps/:id" element={<AppDetailPage />} />
                      <Route path="/files" element={<FilesPage />} />
                      <Route path="/duplicates" element={<DuplicatesPage />} />
                      <Route path="/processing" element={<ProcessingPage />} />
                      <Route path="/webhooks" element={<WebhooksPage />} />
                      <Route path="/activity" element={<ActivityPage />} />
                    </Route>
                  </Route>
                </Routes>
              </SnackbarProvider>
            </Router>
          </AuthenticatedApiProvider>
        </AuthProvider>
      </SessionBusProvider>
    </GlobalStateProvider>
  );
}
